<template>
  <div class="px-4 py-3">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row no-gutters>
        <!-- Phần "THÔNG TIN ĐƠN HÀNG" -->
        <v-col class="pr-2" cols="12" md="7" lg="8">
          <v-card
            class="py-3 px-4 ma-0"
            style="background: #F5F5F5;border: 0.25px solid #c9c8c8;"
            outlined
            tile
          >
            <div class="d-flex align-center justify-space-between">
              <div style="color: #AC0606; font-weight: 600; font-size: 14px;">
                THÔNG TIN ĐƠN HÀNG
              </div>
              <div>
                <v-btn
                  min-width="70"
                  height="32"
                  color="#949494"
                  @click="backToListOrder()"
                >
                  Huỷ
                </v-btn>
                <v-btn
                  v-if="checkAuthorization('oms-order_create')"
                  min-width="70"
                  height="32"
                  class="mr-0"
                  color="#AC0606"
                  @click="createOrder()"
                >
                  Tạo đơn
                </v-btn>
              </div>
            </div>
            <hr
              style="background-color: #838383; height: 1px; border: 0;"
              class="my-2"
            />
            <div>
              <!-- Phần tìm kiếm -->
              <!-- {{ selectedProduct }} -->
              <div>
                <v-autocomplete
                  auto-select-first
                  :items="listProduct"
                  :item-text="
                    (item) => `${item.name} - ${formatPrice(item.price)} VNĐ`
                  "
                  item-value="id"
                  return-object
                  v-model="selectedProduct"
                  placeholder="Tìm theo tên sản phẩm"
                  multiple
                  solo
                  dense
                  clearable
                >
                  <template v-slot:selection="{ index }">
                    <span v-if="index === 0">
                      <span style="margin-right: 2px">
                        {{ `Đã chọn ${selectedProduct.length} sản phẩm` }}
                      </span>
                    </span>
                  </template>
                </v-autocomplete>
              </div>

              <!-- Phần bảng sản phẩm -->
              <div>
                <v-simple-table height="300px" fixed-header>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th
                          class="text-left font-weight-bold"
                          style="min-width: 250px;"
                        >
                          Sản phẩm
                        </th>
                        <th
                          class="text-left font-weight-bold"
                          style="width: 160px;"
                        >
                          Đơn giá
                        </th>
                        <th
                          class="text-left font-weight-bold"
                          style="width: 100px;"
                        ></th>
                        <th
                          class="text-left font-weight-bold"
                          style="width: 160px;"
                        >
                          Số lượng
                        </th>
                        <th class="text-right font-weight-bold">
                          Thành tiền
                        </th>
                        <th
                          class="text-center font-weight-bold"
                          style="width: 100px;"
                        ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in selectedProduct" :key="item.name">
                        <!-- Cột 'Sản phẩm' -->
                        <td>
                          <div class="font-weight-bold">
                            {{ item.name }}
                          </div>
                          <div>
                            <span style="color: #A4A4A4; font-weight: 600;">
                              Nhóm sản phẩm:
                            </span>
                            <span class="font-weight-bold">
                              {{ item.examType }}
                            </span>
                          </div>
                          <div>
                            <span style="color: #A4A4A4; font-weight: 600;">
                              Loại sản phẩm:
                            </span>
                            <span class="font-weight-bold">
                              {{ item.productType }}
                            </span>
                          </div>
                        </td>
                        <!-- Cột 'Đơn giá' -->
                        <td>
                          <div class="price">
                            {{ formatPrice(item.price) }}
                          </div>
                        </td>
                        <!-- Cột 'x' -->
                        <td class="text-center">x</td>
                        <!-- Cột 'Số lượng' -->
                        <td>
                          <v-currency-field
                            v-model="item.quantity"
                            :valueAsInteger="true"
                            :allowNegative="true"
                            :defaultValue="1"
                            :min="1"
                            :max="1000"
                            dense
                            outlined
                            hide-details=""
                            class="input-curency"
                          />
                        </td>
                        <!-- Cột 'Thành tiền' -->
                        <td class="text-right font-weight-bold">
                          {{ formatPrice(item.price * item.quantity) }}
                        </td>
                        <!-- Cột 'Thao tác' -->
                        <td class="text-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <v-icon
                                  style="cursor: pointer;"
                                  @click="removeProduct(item.id)"
                                >
                                  mdi-close
                                </v-icon>
                              </span>
                            </template>
                            <span>Xoá sản phẩm</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>

              <!-- Phần ghi chú, note, thanh toán -->
              <div style="margin-top: 22px;">
                <v-row>
                  <v-col cols="12" sm="6" md="7">
                    <div>
                      <div style="color: #AC0606; font-weight: 600">
                        Ghi chú đơn hàng
                      </div>
                      <v-textarea
                        auto-grow
                        variant="outlined"
                        rows="3"
                        row-height="25"
                        outlined
                        class="note mt-1"
                        v-model="noteOrder"
                        :rules="[
                          (v) =>
                            !v ||
                            v.length < 255 ||
                            'Ghi chú đơn hàng không quá 255 ký tự',
                        ]"
                        placeholder="Nhập ghi chú đơn hàng"
                      ></v-textarea>
                    </div>
                    <div>
                      <div style="color: #AC0606; font-weight: 600">
                        Note vận hành xếp lớp
                      </div>
                      <v-textarea
                        auto-grow
                        variant="outlined"
                        rows="3"
                        row-height="25"
                        outlined
                        class="note mt-1"
                        v-model="noteClass"
                        :rules="[
                          (v) =>
                            !v ||
                            v.length < 255 ||
                            'Note vận hành xếp lớp không quá 255 ký tự',
                        ]"
                        placeholder="Nhập note vận hành xếp lớp"
                      ></v-textarea>
                    </div>
                  </v-col>

                  <v-col cols="6" md="5">
                    <div class="pl-3">
                      <div style="color: #AC0606; font-weight: 600">
                        Thông tin thanh toán
                      </div>
                      <div class="mt-3">
                        <div
                          class="d-flex align-center justify-space-between mt-2"
                        >
                          <div style="color: #000; min-width: 160px; ">
                            Tổng giá trị đơn hàng
                          </div>
                          <div class="info-payment-price">
                            {{ formatPrice(totalOrderValue) }}
                          </div>
                        </div>
                        <div
                          class="d-flex align-center justify-space-between mt-2"
                        >
                          <div style="color: #000; min-width: 160px; ">
                            Phụ phí
                          </div>
                          <div class="info-payment-price">
                            {{ formatPrice(surcharge) }}
                          </div>
                        </div>
                        <div
                          class="d-flex align-center justify-space-between mt-2"
                        >
                          <div style="color: #000; min-width: 160px; ">
                            Đã thanh toán
                          </div>
                          <div class="info-payment-price">
                            {{ formatPrice(alreadyPaid) }}
                          </div>
                        </div>
                        <div
                          class="d-flex align-center justify-space-between mt-2"
                        >
                          <div style="color: #000; min-width: 160px; ">
                            Cần thanh toán
                          </div>
                          <div class="info-payment-price">
                            {{
                              formatPrice(
                                totalOrderValue - alreadyPaid + surcharge
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Phần "THÔNG TIN KHÁCH HÀNG" -->
        <v-col class="pl-2" cols="12" md="5" lg="4">
          <v-card
            class="py-3 px-4 ma-0"
            style="background: #F5F5F5;border: 0.25px solid #c9c8c8;"
            outlined
            tile
          >
            <div class="mt-1">
              <div style="color: #AC0606; font-weight: 600; font-size: 14px;">
                THÔNG TIN KHÁCH HÀNG
              </div>
              <div class="mt-6">
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Số điện thoại
                  </div>
                  <div
                    class="d-flex align-center justify-space-between"
                    style="width: 100%;"
                  >
                    <div style="width: 100%;">
                      <v-autocomplete
                        hide-details=""
                        :items="listCustomer"
                        item-text="mobile"
                        item-value="id"
                        return-object
                        v-model="selectedCustomer"
                        placeholder="Chọn số điện thoại và nhấn enter"
                        solo
                        dense
                        clearable
                        @change="changePhoneNumber()"
                        @click:clear="clearPhone()"
                        @update:search-input="searchInput = $event"
                        @keydown.enter="changeSearchInput"
                      >
                        <template v-slot:item="{ item }">
                          <span style="color: #000;" class="mr-1">{{
                            item.fullName
                          }}</span>
                          <span style="color: #A5A5A5D9;">
                            {{ `- ${item.mobile || "không có sđt"}` }}
                          </span>
                        </template>
                        <template v-slot:selection="{ item }">
                          <span style="margin-right: 2px">
                            {{ `${item.mobile}` }}
                          </span>
                        </template>
                      </v-autocomplete>
                    </div>
                    <div class="ml-2">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="primary" dark v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Nhấn Enter để tìm kiếm</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Tên khách hàng
                  </div>
                  <v-text-field
                    v-model="fullName"
                    placeholder="Tên khách hàng"
                    height="25px"
                    solo
                    dense
                    hide-details
                  ></v-text-field>
                </div>
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Email
                  </div>
                  <div class="info-payment-price text-left">
                    {{ _.get(selectedCustomer, "email", null) }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Địa chỉ -->
            <div class="mt-10">
              <div style="color: #AC0606; font-weight: 600; font-size: 14px;">
                Địa chỉ
              </div>
              <div class="my-3">
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Tỉnh/Thành
                  </div>
                  <div style="width: 100%;">
                    <v-autocomplete
                      hide-details=""
                      :items="listProvince"
                      item-text="ten"
                      item-value="id"
                      v-model="selectedProvince"
                      solo
                      dense
                      placeholder="Chọn tỉnh/thành phố"
                      @change="getListDistrict()"
                    ></v-autocomplete>
                  </div>
                </div>
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Quận/Huyện
                  </div>
                  <div style="width: 100%;">
                    <v-autocomplete
                      hide-details=""
                      :items="listDistrict"
                      item-text="ten"
                      item-value="id"
                      v-model="selectedDistrict"
                      solo
                      dense
                      placeholder="Chọn Quận/Huyện"
                      @change="getListWard()"
                    ></v-autocomplete>
                  </div>
                </div>
                <div class="d-flex align-center justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Phường/Xã
                  </div>
                  <div style="width: 100%;">
                    <v-autocomplete
                      hide-details=""
                      :items="listWard"
                      item-text="ten"
                      item-value="id"
                      v-model="selectedWard"
                      solo
                      dense
                      placeholder="Chọn Phường/Xã"
                    ></v-autocomplete>
                  </div>
                </div>
                <div class="d-flex align-start justify-space-between mt-2">
                  <div style="color: #000; min-width: 160px; ">
                    Địa chỉ chi tiết
                  </div>
                  <v-textarea
                    auto-grow
                    variant="outlined"
                    rows="3"
                    row-height="25"
                    outlined
                    class="note mt-1"
                    v-model="detailAddress"
                    :rules="[
                      (v) =>
                        !v ||
                        v.length < 255 ||
                        'Địa chỉ chi tiết không quá 255 ký tự',
                    ]"
                    placeholder="Nhập địa chỉ chi tiết"
                  ></v-textarea>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import OrderRepository from "@/pages/order-management/services/OrderRepository.js";

export default {
  name: "VhPosFrontendCreateOrder",

  data() {
    return {
      valid: false,
      listProduct: [],
      selectedProduct: [],
      listCustomer: [],
      selectedCustomer: null,
      fullName: null,
      surcharge: 0,
      alreadyPaid: 0,
      noteOrder: null,
      noteClass: null,
      detailAddress: null,
      listProvince: [],
      selectedProvince: null,
      listDistrict: [],
      selectedDistrict: null,
      listWard: [],
      selectedWard: null,
      searchInput: "",
    };
  },

  computed: {
    // Tổng giá trị đơn hàng
    totalOrderValue() {
      let total = 0;
      total = _.sumBy(this.selectedProduct, function(product) {
        return product.quantity * product.price;
      });
      return total;
    },
  },

  created() {
    this.getListProduct();
    this.getListCustomer();
    this.getListProvince();
  },

  methods: {
    // Lấy danh sách sản phẩm
    async getListProduct() {
      const params = {
        productType: "EXAM",
      };
      const res = await OrderRepository.listProduct(params);
      if (res?.success) {
        this.listProduct = res.data;
      }
    },

    // Lấy danh sách khách hàng
    async getListCustomer(limit = 50) {
      const params = {
        limit: limit,
        keyword: this.searchInput || null,
      };
      const res = await OrderRepository.listCustomer(params);
      if (res?.success) {
        this.listCustomer = res.data;
      }
    },

    // Khi thay đổi số điện thoại
    async changePhoneNumber() {
      if (this.selectedCustomer) {
        this.detailAddress = this.selectedCustomer.detailAddress;
        this.fullName = this.selectedCustomer.fullName;
        this.selectedProvince = this.selectedCustomer.tinhId;
        if (this.selectedProvince) {
          await this.getListDistrict();
        }
        this.selectedDistrict = this.selectedCustomer.huyenId;
        if (this.selectedDistrict) {
          await this.getListWard();
        }
        this.selectedWard = this.selectedCustomer.xaId;
      } else {
        this.clearPhone();
      }
    },

    // Xoá số điện thoại
    clearPhone() {
      this.fullName = null;
      this.selectedProvince = null;
      this.selectedDistrict = null;
      this.selectedWard = null;
      this.detailAddress = null;
      this.searchInput = null;
      this.getListCustomer();
    },

    // Thay đổi key search
    changeSearchInput() {
      this.getListCustomer();
    },

    // Huỷ đơn hàng => về trang danh sách đơn hàng
    backToListOrder() {
      this.$router.push({
        name: "OrderManagement",
      });
    },

    // Tạo đơn hàng
    async createOrder() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        if (this.selectedProduct.length && this.selectedCustomer) {
          _.map(this.selectedProduct, (item) => {
            item.productId = item.id;
          });
          const address = this.convertProvince();
          const data = {
            products: this.selectedProduct,
            user: { customerId: this.selectedCustomer.id },
            receiver: {
              name: this.fullName,
              mobile: this.selectedCustomer.mobile,
              email: this.selectedCustomer.email || null,
            },
            address: {
              province: address.tinh,
              district: address.huyen,
              ward: address.xa,
              addressDetail: this.detailAddress,
            },
            description: this.noteOrder,
            operationNote: this.noteClass,
          };
          const res = await OrderRepository.createOrder(data);
          if (res.success) {
            this.$swal({
              icon: "success",
              title: "Thành công",
              text: "Thao tác thành công!",
            }).then(() => {
              this.backToListOrder();
            });
          } else {
            this.$swal({
              icon: "error",
              title: "Lỗi",
              text: "Opps! Đã có lỗi xảy ra",
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: "Lỗi",
            text: "Chọn sản phẩm và thông tin khách hàng",
          });
        }
      }
    },

    // Tìm tên tinh/huyen/xa
    convertProvince() {
      const data = {};
      const tinhObj = _.find(this.listProvince, { id: this.selectedProvince });
      if (tinhObj) {
        data.tinh = tinhObj.ten;
      }
      const huyenObj = _.find(this.listDistrict, { id: this.selectedDistrict });
      if (huyenObj) {
        data.huyen = huyenObj.ten;
      }
      const xaObj = _.find(this.listWard, { id: this.selectedWard });
      if (xaObj) {
        data.xa = xaObj.ten;
      }
      return data;
    },

    // Xoá 1 sản phẩm
    removeProduct(id) {
      this.selectedProduct = _.remove(this.selectedProduct, (product) => {
        return product.id !== id;
      });
    },

    // Lấy danh sách Tỉnh/Thành Phố
    async getListProvince() {
      const res = await OrderRepository.listProvince();
      if (res.success) {
        this.listProvince = res.data;
      }
    },

    // Lấy danh sách Quận/Huyện
    async getListDistrict() {
      this.selectedDistrict = null;
      this.selectedWard = null;
      const res = await OrderRepository.listDistrict(this.selectedProvince);
      if (res.success) {
        this.listDistrict = res.data;
      }
    },

    // Lấy danh sách Phường/Xã
    async getListWard() {
      this.selectedWard = null;
      const data = {
        provinceId: this.selectedProvince,
        districtId: this.selectedDistrict,
      };
      const res = await OrderRepository.listWard(data);
      if (res.success) {
        this.listWard = res.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__control {
  min-height: 10px;
}

::v-deep .v-data-table th {
  font-size: 16px !important;
}
::v-deep .v-data-table td,
::v-deep .v-data-table table thead tr th {
  font-size: 14px !important;
  padding: 15px 12px !important;
}

.v-label {
  font-size: 10px;
}
.info-payment-price {
  height: 38px;
  background: #d9d9d9;
  border: 1px solid #00000033;
  border-radius: 3px;
  width: 100%;
  text-align: right;
  padding: 5px 4px;
}
::v-deep .note .v-input__slot {
  background: #fff !important;
}
.price {
  background: #d9d9d9;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 5px;
  font-weight: 400;
  height: 38px;
  line-height: 28px;
  border-radius: 4px;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 38px !important;
}
</style>
